import React from "react";
import { useSearchParams } from "react-router-dom";

export default function useCatalogFilters(defaults) {
  const [params, setParams] = useSearchParams();
  const current = React.useRef(params);
  current.current = params;
  const serialized = JSON.stringify(
    Object.entries(defaults).map(([key, fallback]) => [
      key,
      Array.isArray(fallback)
        ? params.getAll(key)
        : params.get(key) || fallback,
    ]),
  );
  const filters = React.useMemo(
    () => Object.fromEntries(JSON.parse(serialized)),
    [serialized],
  );
  const setFilter = React.useCallback(
    (key, update) => {
      const next = new URLSearchParams(current.current);
      const fallback = defaults[key];
      const previous = Array.isArray(fallback)
        ? next.getAll(key)
        : next.get(key) || fallback;
      const value = typeof update === "function" ? update(previous) : update;
      next.delete(key);
      if (Array.isArray(value)) value.forEach((item) => next.append(key, item));
      else if (value && value !== fallback) next.set(key, value);
      if (next.toString() === current.current.toString()) return;
      // React Router does not queue functional search updates. Keep consecutive
      // filter removals in one event based on the latest requested URL.
      current.current = next;
      setParams(next, { replace: true });
    },
    [defaults, setParams],
  );
  return [filters, setFilter];
}
